import { BiCaretDown, BiCaretUp } from 'react-icons/bi';
import clsx from 'clsx';

import useTrendingPercent from '@/hooks/useTrendingPercent';
import { SkuTrendingBadgeProps } from '@/types/sku';

export default function SkuTrendingBadge({ sku }: SkuTrendingBadgeProps) {
  const trendingPercent = useTrendingPercent(sku.orders || [], sku.retailPrice || 0);

  const baseClasses =
    'tw-flex tw-items-center tw-justify-center tw-rounded-full tw-px-[8px] tw-text-base tw-font-medium max-nine:tw-text-xs-lower tw-whitespace-nowrap';

  const config = {
    positive: {
      classes: 'tw-bg-mint-frost tw-text-bid-600',
      icon: <BiCaretUp className="me-1" />,
      text: `${trendingPercent} %`,
    },
    neutral: {
      classes: 'tw-bg-ask-100 tw-text-ask-800',
      icon: null,
      text: '--%',
    },
    negative: {
      classes: 'tw-bg-red-100 tw-text-red-600',
      icon: <BiCaretDown className="me-1" />,
      text: `${trendingPercent} %`,
    },
  };

  let state;
  if (trendingPercent === 0) {
    state = config.neutral;
  } else if (trendingPercent > 0) {
    state = config.positive;
  } else {
    state = config.negative;
  }

  return (
    <span className={clsx(baseClasses, state.classes)}>
      {state.icon}
      <span>{state.text}</span>
    </span>
  );
}
